import script from "./SimpleRadioButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleRadioButton.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleRadioButton.vue?vue&type=style&index=0&id=bd4f7668&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd4f7668"]])

export default __exports__